import { makeStyles, createStyles } from '@material-ui/core';
import React from 'react'
// @ts-ignore
import ConfettiCanvas from "react-confetti-canvas";

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      position: "absolute",
      zIndex: 1100,
      height: "100%",
      width: "100%",
      top: 0
    }
  })
);


interface ConfettisProps {
  show: boolean;
}
function Confettis({ show }: ConfettisProps) {
  const classes = useStyles();
  return (
  <>
      {show &&
        <div className={classes.root}>
        <ConfettiCanvas
          colors={[
            ["#124379", "#d2edf3"],
            ["#129ebf", "#124379"],
            ["#129ebf", "#d2edf3"],
          ]}
          duration={0.07}
          paperCount={500}
          ribbonCount={40}
          ribbonParticleCount={30}
          ribbonParticleDist={5.0}
          ribbonParticleThick={4.0}
          ribbonParticleAngle={90}
          ribbonParticleMass={0.5}
          ribbonParticleDrag={0.05}
          />  
      </div>}
  </>
  )
}

export default Confettis